import React, {useEffect, useState} from 'react'
import classes from './logsPage.module.scss'
import {Controller, useForm} from 'react-hook-form'
import Select from 'react-select'
import {logsService} from '../../../api/logsService'
import {useNavigate} from "react-router-dom";
import {DisplayedByNum} from "../../common/SortByNum";
import {PaginationBottom} from "../../common/PaginationBottom/PaginationBottom";
import {commonServices} from "../../../api/commonServices";
import { useSelector } from 'react-redux'
import { toast } from 'react-toastify'


const LogsPage = () => {
    const navigate = useNavigate(); // Hook to navigate programmatically
    const [form, setForm] = useState(false)
    const [options, setOptions] = useState([])
    const [logs, setLogs] = useState()
    const [logsFormed, setLogsFormed] = useState(false)
    const [perPage, setPerPage] = useState(10); // State for items per page
    const [limit, setLimit] = useState(0); // Total number of items
    const [currentPage, setCurrentPage] = useState(1); // Current page number
    const [filters, setFilters] = useState({
        offset: 0,
        limit: 10,
    });
    const role = useSelector(state=>state.login.userInfo.permissions.users_activity)

    const {
        register,
        handleSubmit,
        formState: {errors},
        control,
        watch
    } = useForm()

    const info = watch();

    const onSubmit = (data) => {
        if (data.user){
            getlogs(data.dateStart, data.dateFinished, data.user.id)
        }
    }

    useEffect(() => {
        if (!role){
              navigate('/Home')
              toast.error('В доступі відмовлено!')
            }
        if (!form){
            getWorkers()
            setForm(true)
        }
    }, [])

    useEffect(() => {
        // Fetch workers based on filters
        if (info?.dateStart && info?.dateFinished && info?.user.id){
            getlogs(info?.dateStart, info?.dateFinished, info?.user.id)
        }

    }, [filters, navigate]);

    const getWorkers = async() => {
        await commonServices.getAllWorkerBasicList().then(res => {
            if (res?.data){
                setOptions(res?.data.map(el => ({
                    "value": el.name,
                    "label": el.name,
                    "id": el.id,
                    "type": 'option'
                })))
            }
        })
    }

    const getlogs = async(start, end, id) => {
        // Filter out empty filters
        const nonEmptyFilters = Object.fromEntries(
            Object.entries(filters).filter(([key, value]) => value !== '')
        );

        const queryParams = new URLSearchParams(nonEmptyFilters).toString(); // Prepare query params for URL

        await logsService.getLogs(start, end, id, '&' + queryParams).then(res => {
            if (res?.data){
                let arr = []
                res.data.data.map(el => {
                    let obj = {
                        "time": new Date(el.timestamp),
                        "action": el.actionMessage
                    }
                    arr.push(obj)
                })
                setLogs(arr)
                setLogsFormed(true)
                setLimit(res?.data?.count); // Set total count of results
                navigate(`?${queryParams}`); // Update URL with filter parameters
            }
        })
    }

    const handleLimitChange = (e) => {
        const newPerPage = e.target.value;
        setFilters((prevFilters) => ({
            ...prevFilters,
            limit: newPerPage, // Update limit in filters
            offset: 0, // Reset pagination on limit change
        }));
        setPerPage(newPerPage);
        setCurrentPage(1); // Reset to first page
    };

    // Handle page change for pagination
    const handlePaginationChange = (pageNum) => {
        const offset = pageNum * perPage; // Calculate offset based on page number
        setFilters((prevFilters) => ({
            ...prevFilters,
            offset: offset, // Update offset in filters
        }));
        setCurrentPage(pageNum + 1); // Update current page
    };

    return (
        <div className={classes.container}>
            <div className={classes.logsContainerInput}>
                <h1>Виберіть параметр сортування</h1>
                <form className={classes.form} onSubmit={handleSubmit(onSubmit)}>
                    <div style={{position: 'relative'}}>
                        <Controller
                            control={control}
                            name='user'
                            render={({field: {onChange, value}}) => (
                                <Select
                                    className={classes.select}
                                    options={options}
                                    value={value ? value : []}
                                    onChange={onChange}
                                    disableSearch
                                    hasSelectAll={false}
                                    placeholder={'Оберіть співробітника'}

                                />
                            )}
                            {...register('user', {
                                required: true,
                            })}
                        />
                        {errors['user'] && ( // Show error message if validation fails
                            <p style={{
                                color: 'red', textAlign: 'center', position: "absolute", left: "50px",
                                top: "45px"
                            }}>
                                {errors['user'].message || "Оберіть працівника"}
                            </p>
                        )}
                    </div>

                    <legend className={classes.legend} htmlFor='dateStart'></legend>
                    <input className={classes.input} type='date' {...register('dateStart')}/>
                    <legend className={classes.legend} htmlFor='dateFinished'></legend>
                    <input className={classes.input} type='date' {...register('dateFinished')}/>
                    <button className={classes.button} type="submit">Застосувати</button>
                </form>
            </div>

            <div className={classes.logsWrapper}>
                {!!logs?.length && <div className={classes.pagination__container}>
                    <DisplayedByNum perPage={perPage} handleLimitChange={handleLimitChange} />
                </div>}
                <div className={classes.logsContainer}>
                    {logs?.length ?
                        <div className={classes.logsBox}>
                            <div className={classes.logs__header__wrapper}>
                                <div style={{display: "flex", justifyContent: "flex-start", width: "20%"}}>Дата:</div>
                                <div style={{display: "flex", justifyContent: "flex-start"}}>Повідомлення:</div>
                            </div>
                            {logsFormed && logs.map(el => {
                                return (<div className={classes.logs__wrapper}>
                                        <div className={classes.date__info}>{el.time.toLocaleDateString()}</div>
                                        <div className={classes.action__info}>{el.action}</div>
                                    </div>
                                )
                            })}
                        </div> :
                        <div>Немає даних</div>}
                </div>
                {!!logs?.length && <div style={{marginBottom: "30px"}}>
                    <PaginationBottom limit={limit} perPage={perPage} currentPage={currentPage} setCurrentPage={handlePaginationChange}/> </div>
                }
            </div>
        </div>
    )
}

export default LogsPage